const WORDS = ["Diszkréció", "Fix ár", "Hazai szakemberek", "Ózonos szagtalanítás", "Biológiai fertőtlenítés", "Jelzés nélküli autók", "Visszahívás 1 órán belül"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display whitespace-nowrap px-6 text-4xl font-black tracking-tight sm:text-6xl lg:text-7xl ${i % 2 ? "text-outline" : "text-[var(--navy)]"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-[var(--crimson)] sm:h-8 sm:w-8" fill="currentColor" aria-hidden="true">
          <path d="M12 0c.7 6.6 4.7 10.6 12 12-7.3 1.4-11.3 5.4-12 12-.7-6.6-4.7-10.6-12-12C7.3 10.6 11.3 6.6 12 0z" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Értékeink" className="overflow-hidden border-y border-[var(--navy)]/10 bg-[var(--ivory-2)] py-7 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
